export let InitialState = {
  vulnerabilityTypes: [],
  paymentMethodTypes: [],
  usdBankTypes: [],
  countries: [],
}
